import { render } from "./Ladder.vue?vue&type=template&id=65e131ec&scoped=true"
import script from "./Ladder.vue?vue&type=script&lang=js"
export * from "./Ladder.vue?vue&type=script&lang=js"

import "./Ladder.vue?vue&type=style&index=0&id=65e131ec&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e131ec"]])

export default __exports__